export default "__VITE_ASSET__QMVKbawW__"